module.exports = __webpack_public_path__ + "img/subscribers/dragndrop.204339.png";